<template>
    <div>
        <div class="polygon-container">
            <!--<div class="polygon"></div>-->
            <div class="container-fluid layout-wrapper mb-0">
                <h4 class="text-center"
                    v-if="role === 'ادمین' || role ==='منشی'|| role ==='بازاریاب'|| role ==='سرپرست بازاریابی'|| role ==='مدیر بازاریابی'">
                    پیگیری ها</h4>
                <div class="row">
                    <div class="col-lg-3 col-md-6 mb-4 clickable" v-if="role === role ==='بازاریاب'"
                         @click="redirectToByParam('customerFollow' , true)">
                        <div class="card header-report bg-gradient-pastel-yellow">
                            <div class="card-body">
                                <h5 class="text-right">پیگیری های من</h5>
                                <div class="loader" v-if="isLoading">Loading...</div>
                                <div v-else class="statistic-container">
                                    <div>
                                        <h5 class="text-white mb-0">
                                            <strong>{{myfollows}}</strong>
                                        </h5>
                                        <!--<img src="/img/gold-medal.svg" class="img-fluid medal">-->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-4 clickable" v-if="role === 'ادمین' || role ==='منشی'|| role ==='سرپرست بازاریابی'|| role ==='مدیر بازاریابی'"
                         @click="redirectToByParam('recordInquiry' , true)">
                        <div class="card header-report bg-gradient-pastel-yellow"
                             >
                            <div class="card-body">
                                <h5 class="text-right">پیگیری ها</h5>
                                <div class="loader" v-if="isLoading">Loading...</div>
                                <div v-else class="statistic-container">
                                    <div>
                                        <h5 class="text-white mb-0">
                                            <strong>{{allfollows}}</strong>
                                        </h5>
                                        <!--<img src="/img/gold-medal.svg" class="img-fluid medal">-->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-4 clickable" v-if="role === 'ادمین' || role ==='منشی'|| role ==='سرپرست بازاریابی'|| role ==='مدیر بازاریابی'|| role ==='بازاریاب'"
                         @click="redirectToByParam('inquiris' , true)">
                        <div class="card header-report bg-gradient-pastel-yellow"
                        >
                            <div class="card-body">
                                <h5 class="text-right">استعلام های در حال ثبت</h5>
                                <div class="loader" v-if="isLoading">Loading...</div>
                                <div v-else class="statistic-container">
                                    <div>
                                        <h5 class="text-white mb-0">
                                            <strong>{{inquirsInRecord}}</strong>
                                        </h5>
                                        <!--<img src="/img/gold-medal.svg" class="img-fluid medal">-->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <!--<h4 class="text-center"  v-if="role === 'ادمین' || role ==='منشی'|| role ==='سرپرست بازاریابی'|| role ==='مدیر بازاریابی'|| role ==='بازاریاب'"-->
                               <!--&gt;میز کار</h4>-->

                <div class="col-12 overflow-auto" style="max-height: 32rem;">
                    <table class="table table-hover table-striped mb-2">
                        <thead>
                        <tr>
                            <th class="text-center">شنبه</th>
                            <th class="text-center">یک شنبه</th>
                            <th class="text-center">دوشنبه</th>
                            <th class="text-center">سه شنبه</th>
                            <th class="text-center">چهار شنبه</th>
                            <th class="text-center">پنج شنبه</th>


                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="it in inquiry" v-if="inquiry.length>0" >
                            <td class="text-wrap text-center col-2" style="font-size: 13px">{{it.saturday}}</td>
                            <td class="text-wrap text-center col-2" style="font-size: 13px">{{it.sunday}}</td>
                            <td class="text-wrap text-center col-2" style="font-size: 13px">{{it.monday}}</td>
                            <td class="text-wrap text-center col-2" style="font-size: 13px">{{it.tuesday}}</td>
                            <td class="text-wrap text-center col-2" style="font-size: 13px">{{it.wednesday}}</td>
                            <td class="text-wrap text-center col-2" style="font-size: 13px">{{it.thursday}}</td>

                        </tr>
                        </tbody>
                    </table>
                </div>


        </div>
    </div>

</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import * as $ from "jquery";
    import Moment from "moment-jalali";

    export default {
        name: 'home',
        components: {},
        data() {
            return {
                isLoading: false,
                model: {
                    myWallet: 0,
                    // مسابقات شرکت کرده
                    meInMatchRunning: 0,
                    meInMatchEnded: 0,
                    meInMatchFuture: 0,
                    // مسابقات برگزار کرده
                    myMatchRunning: 0,
                    myMatchEnded: 0,
                    myMatchFuture: 0,
                    // قهرمانی های من
                    goldMedals: 0,
                    silverMedals: 0,
                    myMatchesDetails: {},
                    meInMatchDetail: {}
                },
                lastMaches: [],
                myWallet: 0,
                likes: 0,
                myRequst: [],
                myfollows: 0,
                allfollows: 0,
                inquirsInRecord:0,
                inquirylist : [{
                    // categoryId :"",
                    // categoryName :"",
                    customerFullName :"",
                    customerId :"",
                    expiryDate :"",
                    // expiryHour :"",
                    inquiryId :0,
                    // inquiriType :"",
                    // inquiryStatus :"",
                    // inquirynumber :"",
                    // mainCategory :"",
                    // mainCategoryId :"",
                    productCode :"",
                    productCount :"",
                    // productId :"",
                    productName :"",
                    // recordDate  :"",
                    // recordHour :"",
                    // registrationDate :"",
                    // resultInquiry :"",
                    // settlementPeriod :"",
                    // startDate :"",
                    // startHour :"",
                    // unitId :"",
                    // unitName :"",
                    userFamily :"",
                    // userId :"",
                    // userName :"",
                }],
                inquiry :[{
                    // categoryId :"",
                    // categoryName :"",
                    // customerFullName :"",
                    // customerId :"",
                    // expiryDate :"",
                    // expiryHour :"",
                    // inquiryid :"",
                    // inquiriType :"",
                    // inquiryStatus :"",
                    // inquirynumber :"",
                    // mainCategory :"",
                    // mainCategoryId :"",
                    // productCode :"",
                    // productCount :"",
                    // productId :"",
                    // productName :"",
                    // recordDate  :"",
                    // recordHour :"",
                    // registrationDate :"",
                    // resultInquiry :"",
                    // settlementPeriod :"",
                    // startDate :"",
                    // startHour :"",
                    // unitId :"",
                    // unitName :"",
                    // userFamily :"",
                    // userId :"",
                    // userName :"",
                    saturday :"",
                    sunday :"",
                    monday :"",
                    tuesday :"",
                    wednesday :"",
                    thursday  :"",
                    friday :"",

                }],

                role: "",
                strdate : "",
                usr :[],
                userName:"",
                sat:0,
                sun:0,
                mon:0,
                tue:0,
                wed:0,
                thu:0,
                fri:0,
                count:1,


            }
        },
        mounted() {
            // this.getDashboardData();
            const userName = localStorage.getItem('userName');
            if (userName === undefined || userName === "") {
                this.$noty.error('لطفا ابتدا وارد حساب کاربری خود شوید!');
                this.$router.push({name: "login"})
            }
            this.role = localStorage.getItem('role');
            this.getDashboardData();
            this.getinquirys();
            $("body").addClass("polygon");



        },
        methods: {
            getDashboardData() {
                this.isLoading = true;
                new BaseService("Inquiry", "/SearchInquirysReached").getList().then(response => {
                    this.isLoading = false;

                    //this.myfollows = response.data.myfollows;
                    this.allfollows = response.data.inquiriReachedCount    ;//.allfollows;
                    this.inquirsInRecord = response.data.inquiriInRecordCount;

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                // new BaseService("ReportMainMatches", "/GetMatchesForDashboard").getList().then(response => {
                //     console.log(response.data);
                //     this.lastMaches = response.data.data;
                // }).catch(error => {
                //     Utils.handleErrorWithNotification(error.data, this.$noty);
            },
            getinquirys() {
                let dateObj = new Date().toJSON();
                //this.strdate = this.gregorianToJalali(dateObj, false)
                //this.strdate = this.jalaliToGregorian(dateObj, false)
                //this.strdate = Moment(this.strdate).format('YYYY/MM/DD HH:mm');
                this.strdate = dateObj.toString().substr(0,4)+dateObj.toString().substr(5,2)+dateObj.toString().substr(8,2);
                new BaseService("inquiry", `/GetInquirysList/${this.strdate}`).getList().then(response => {

                    let addchk=true;
                    for (let list of response.data) {

                        addchk=true;
                        for(let inquiri of this.inquirylist){

                            if(inquiri.inquiryId.toString() ===list.inquiryId.toString()){
                                inquiri.productName = inquiri.productName +"- " +list.productName;
                               addchk=false;
                            }
                        }
                        if(addchk){

                            if(this.count.toString() ==="1"){

                                this.inquirylist[0].customerFullName=list.customerFullName;
                                this.inquirylist[0].customerId =list.customerId;
                                this.inquirylist[0].expiryDate = list.expiryDate;
                                this.inquirylist[0].inquiryId =list.inquiryId;
                                this.inquirylist[0].productCode = list.productCode;
                                this.inquirylist[0].productCount= list.productCount;
                                this.inquirylist[0].productName =  list.productName;
                                this.inquirylist[0].userFamily=  list.userFamily;
                                this.count++;

                            }else
                            {

                                this.inquirylist.push({
                                    customerFullName : list.customerFullName ,
                                    customerId :list.customerId,
                                    expiryDate  : list.expiryDate,
                                    inquiryId : list.inquiryId,
                                    productCode : list.productCode,
                                    productCount : list.productCount,
                                    productName : list.productName ,
                                    userFamily :  list.userFamily,

                                });
                                this.count++;

                            }
                        }
                    }

                    this.count=1;
                    for (let list of this.inquirylist) {

                        if (Moment(list.expiryDate).day() === 5) {
                            if (this.count.toString() === this.sat.toString()) {

                                this.count++;
                                this.sat++;
                                this.inquiry.push({
                                    saturday: list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily,
                                    sunday: "",
                                    monday: "",
                                    tuesday: "",
                                    wednesday: "",
                                    thursday: "",
                                    friday: ""
                                });
                            } else if (this.count > this.sat) {
                                this.inquiry[this.sat].saturday = list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily;
                                this.sat++;
                            }
                        }
                        if (Moment(list.expiryDate).day() === 6) {

                            if (this.count.toString() === this.sun.toString()) {

                                this.count++;
                                this.sun++;
                                this.inquiry.push({
                                    saturday: "",
                                    sunday: list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily,
                                    monday: "",
                                    tuesday: "",
                                    wednesday: "",
                                    thursday: "",
                                    friday: "",
                                });

                            }
                            else if (this.count > this.sun) {
                                this.inquiry[this.sun].saturday = list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily;
                                this.sun++;
                            }

                        }

                        if (Moment(list.expiryDate).day() === 0) {
                            if (this.count.toString() === this.mon.toString()) {
                                this.count++;
                                this.mon++;
                                this.inquiry.push({
                                    saturday: "",
                                    sunday: "",
                                    monday: list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily,
                                    tuesday: "",
                                    wednesday: "",
                                    thursday: "",
                                    friday: "",
                                });
                            }
                            else if (this.count > this.mon) {
                                this.inquiry[this.mon].monday = list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily;
                                this.mon++;
                            }
                        }
                        if (Moment(list.expiryDate).day() === 1) {
                            if (this.count.toString() === this.tue.toString()) {
                                this.count++;
                                this.tue++;
                                this.inquiry.push({
                                    saturday: "",
                                    sunday: "",
                                    monday: "",
                                    tuesday: list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily,
                                    wednesday: "",
                                    thursday: "",
                                    friday: ""
                                });
                            }
                            else if (this.count > this.tue) {
                                this.inquiry[this.tue].tuesday = list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily;
                                this.tue++;
                            }
                        }
                        if (Moment(list.expiryDate).day() === 2) {
                            if (this.count.toString() === this.wed.toString()) {
                                this.count++;
                                this.wed++;
                                this.inquiry.push({
                                    saturday: "",
                                    sunday: "",
                                    monday: "",
                                    tuesday: "",
                                    wednesday: list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily,
                                    thursday: "",
                                    friday: ""
                                });

                            }
                            else if (this.count > this.wed) {
                                this.inquiry[this.wed].wednesday = list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily;
                                this.wed++;
                            }
                        }
                        if (Moment(list.expiryDate).day() === 3) {
                            if (this.count.toString() === this.thu.toString()) {
                                this.count++;
                                this.thu++;
                                this.inquiry.push({
                                    saturday: "",
                                    sunday: "",
                                    monday: "",
                                    tuesday: "",
                                    wednesday: "",
                                    thursday: list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily,
                                    friday: ""
                                });
                            }
                            else if (this.count > this.thu) {
                                this.inquiry[this.thu].thursday = list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily;
                                this.thu++;
                            }
                        }
                        if (Moment(list.expiryDate).day() === 4) {
                            if (this.count.toString() === this.fri.toString()) {
                                this.count++;
                                this.fri++;
                                this.inquiry.push({
                                    saturday: "",
                                    sunday: "",
                                    monday: "",
                                    tuesday: "",
                                    wednesday: "",
                                    thursday: "",
                                    friday: list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily,
                                });
                            }
                            else if (this.count > this.fri) {
                                this.inquiry[this.fri].friday = list.customerFullName + " - " + list.productName + " - " + list.productCount + " - " + list.userFamily;
                                this.fri++;
                            }
                        }

                        {
                            // if(Moment(list.expiryDate).day()===5){
                            //     this.inquiry.push({
                            //         categoryId : list.categoryId,
                            //         categoryName :list.categoryId,
                            //         customerFullName :list.customerFullName,
                            //         customerId :list.customerId,
                            //         expiryDate :list.expiryDate,
                            //         expiryHour :list.expiryHour,
                            //         inquiryid :list.id,
                            //         inquiriType :list.inquiriType,
                            //         inquiryStatus :list.inquiryStatus,
                            //         inquirynumber :list.inquirynumber,
                            //         mainCategory :list.mainCategory,
                            //         mainCategoryId :list.mainCategoryId,
                            //         productCode :list.productCode,
                            //         productCount :list.productCount,
                            //         productId :list.productId,
                            //         productName :list.productName,
                            //         recordDate  :list.recordDate,
                            //         recordHour :list.recordHour,
                            //         registrationDate :list.registrationDate,
                            //         startDate :list.startDate,
                            //         startHour :list.startHour,
                            //         unitId :list.unitId,
                            //         unitName :list.unitName,
                            //         userFamily :list.userFamily,
                            //         userId :list.userId,
                            //         userName :list.userFamily,
                            //         saturday :list.customerFullName+ " - "+ list.productName+ " - " +list.productCount+ " - " +this.userFamily,
                            //         sunday :"",
                            //         monday :"",
                            //         tuesday :"",
                            //         wednesday :"",
                            //         thursday  :"",
                            //         friday :"",
                            //     });
                            // }
                            // if(Moment(list.expiryDate).day()===6){
                            //     this.inquiry.push({
                            //         categoryId : list.categoryId,
                            //         categoryName :list.categoryId,
                            //         customerFullName :list.customerFullName,
                            //         customerId :list.customerId,
                            //         expiryDate :list.expiryDate,
                            //         expiryHour :list.expiryHour,
                            //         inquiryid :list.id,
                            //         inquiriType :list.inquiriType,
                            //         inquiryStatus :list.inquiryStatus,
                            //         inquirynumber :list.inquirynumber,
                            //         mainCategory :list.mainCategory,
                            //         mainCategoryId :list.mainCategoryId,
                            //         productCode :list.productCode,
                            //         productCount :list.productCount,
                            //         productId :list.productId,
                            //         productName :list.productName,
                            //         recordDate  :list.recordDate,
                            //         recordHour :list.recordHour,
                            //         registrationDate :list.registrationDate,
                            //         startDate :list.startDate,
                            //         startHour :list.startHour,
                            //         unitId :list.unitId,
                            //         unitName :list.unitName,
                            //         userFamily :list.userFamily,
                            //         userId :list.userId,
                            //         userName :list.userFamily,
                            //         saturday :"",
                            //         sunday :list.customerFullName+ " - "+ list.productName+ " - " +list.productCount+ " - " +this.userFamily,
                            //         monday :"",
                            //         tuesday :"",
                            //         wednesday :"",
                            //         thursday  :"",
                            //         friday :"",
                            //     });
                            // }
                            // if(Moment(list.expiryDate).day()===0){
                            //     this.inquiry.push({
                            //         categoryId : list.categoryId,
                            //         categoryName :list.categoryId,
                            //         customerFullName :list.customerFullName,
                            //         customerId :list.customerId,
                            //         expiryDate :list.expiryDate,
                            //         expiryHour :list.expiryHour,
                            //         inquiryid :list.id,
                            //         inquiriType :list.inquiriType,
                            //         inquiryStatus :list.inquiryStatus,
                            //         inquirynumber :list.inquirynumber,
                            //         mainCategory :list.mainCategory,
                            //         mainCategoryId :list.mainCategoryId,
                            //         productCode :list.productCode,
                            //         productCount :list.productCount,
                            //         productId :list.productId,
                            //         productName :list.productName,
                            //         recordDate  :list.recordDate,
                            //         recordHour :list.recordHour,
                            //         registrationDate :list.registrationDate,
                            //         startDate :list.startDate,
                            //         startHour :list.startHour,
                            //         unitId :list.unitId,
                            //         unitName :list.unitName,
                            //         userFamily :list.userFamily,
                            //         userId :list.userId,
                            //         userName :list.userFamily,
                            //         saturday :"",
                            //         sunday :"",
                            //         monday :list.customerFullName+ " - "+ list.productName+ " - " +list.productCount+ " - " +this.userFamily,
                            //         tuesday :"",
                            //         wednesday :"",
                            //         thursday  :"",
                            //         friday :"",
                            //     });
                            // }
                            // if(Moment(list.expiryDate).day()===1){
                            //     this.inquiry.push({
                            //         categoryId : list.categoryId,
                            //         categoryName :list.categoryId,
                            //         customerFullName :list.customerFullName,
                            //         customerId :list.customerId,
                            //         expiryDate :list.expiryDate,
                            //         expiryHour :list.expiryHour,
                            //         inquiryid :list.id,
                            //         inquiriType :list.inquiriType,
                            //         inquiryStatus :list.inquiryStatus,
                            //         inquirynumber :list.inquirynumber,
                            //         mainCategory :list.mainCategory,
                            //         mainCategoryId :list.mainCategoryId,
                            //         productCode :list.productCode,
                            //         productCount :list.productCount,
                            //         productId :list.productId,
                            //         productName :list.productName,
                            //         recordDate  :list.recordDate,
                            //         recordHour :list.recordHour,
                            //         registrationDate :list.registrationDate,
                            //         startDate :list.startDate,
                            //         startHour :list.startHour,
                            //         unitId :list.unitId,
                            //         unitName :list.unitName,
                            //         userFamily :list.userFamily,
                            //         userId :list.userId,
                            //         userName :list.userFamily,
                            //         saturday :"",
                            //         sunday :"",
                            //         monday :"",
                            //         tuesday :list.customerFullName+ " - "+ list.productName+ " - " +list.productCount+ " - " +this.userFamily,
                            //         wednesday :"",
                            //         thursday  :"",
                            //         friday :"",
                            //     });
                            // }
                            // if(Moment(list.expiryDate).day()===2){
                            //     this.inquiry.push({
                            //         categoryId : list.categoryId,
                            //         categoryName :list.categoryId,
                            //         customerFullName :list.customerFullName,
                            //         customerId :list.customerId,
                            //         expiryDate :list.expiryDate,
                            //         expiryHour :list.expiryHour,
                            //         inquiryid :list.id,
                            //         inquiriType :list.inquiriType,
                            //         inquiryStatus :list.inquiryStatus,
                            //         inquirynumber :list.inquirynumber,
                            //         mainCategory :list.mainCategory,
                            //         mainCategoryId :list.mainCategoryId,
                            //         productCode :list.productCode,
                            //         productCount :list.productCount,
                            //         productId :list.productId,
                            //         productName :list.productName,
                            //         recordDate  :list.recordDate,
                            //         recordHour :list.recordHour,
                            //         registrationDate :list.registrationDate,
                            //         startDate :list.startDate,
                            //         startHour :list.startHour,
                            //         unitId :list.unitId,
                            //         unitName :list.unitName,
                            //         userFamily :list.userFamily,
                            //         userId :list.userId,
                            //         userName :list.userFamily,
                            //         saturday :"",
                            //         sunday :"",
                            //         monday :"",
                            //         tuesday :"",
                            //         wednesday :list.customerFullName+ " - "+ list.productName+ " - " +list.productCount+ " - " +this.userFamily,
                            //         thursday  :"",
                            //         friday :"",
                            //     });
                            // }
                            // if(Moment(list.expiryDate).day()===3){
                            //     this.inquiry.push({
                            //         categoryId : list.categoryId,
                            //         categoryName :list.categoryId,
                            //         customerFullName :list.customerFullName,
                            //         customerId :list.customerId,
                            //         expiryDate :list.expiryDate,
                            //         expiryHour :list.expiryHour,
                            //         inquiryid :list.id,
                            //         inquiriType :list.inquiriType,
                            //         inquiryStatus :list.inquiryStatus,
                            //         inquirynumber :list.inquirynumber,
                            //         mainCategory :list.mainCategory,
                            //         mainCategoryId :list.mainCategoryId,
                            //         productCode :list.productCode,
                            //         productCount :list.productCount,
                            //         productId :list.productId,
                            //         productName :list.productName,
                            //         recordDate  :list.recordDate,
                            //         recordHour :list.recordHour,
                            //         registrationDate :list.registrationDate,
                            //         startDate :list.startDate,
                            //         startHour :list.startHour,
                            //         unitId :list.unitId,
                            //         unitName :list.unitName,
                            //         userFamily :list.userFamily,
                            //         userId :list.userId,
                            //         userName :list.userFamily,
                            //         saturday :"",
                            //         sunday :"",
                            //         monday :"",
                            //         tuesday :"",
                            //         wednesday :"",
                            //         thursday  :list.customerFullName+ " - "+ list.productName+ " - " +list.productCount+ " - " +this.userFamily,
                            //         friday :"",
                            //     });
                            // }
                            // if(Moment(list.expiryDate).day()===4){
                            //     this.inquiry.push({
                            //         categoryId : list.categoryId,
                            //         categoryName :list.categoryId,
                            //         customerFullName :list.customerFullName,
                            //         customerId :list.customerId,
                            //         expiryDate :list.expiryDate,
                            //         expiryHour :list.expiryHour,
                            //         inquiryid :list.id,
                            //         inquiriType :list.inquiriType,
                            //         inquiryStatus :list.inquiryStatus,
                            //         inquirynumber :list.inquirynumber,
                            //         mainCategory :list.mainCategory,
                            //         mainCategoryId :list.mainCategoryId,
                            //         productCode :list.productCode,
                            //         productCount :list.productCount,
                            //         productId :list.productId,
                            //         productName :list.productName,
                            //         recordDate  :list.recordDate,
                            //         recordHour :list.recordHour,
                            //         registrationDate :list.registrationDate,
                            //         startDate :list.startDate,
                            //         startHour :list.startHour,
                            //         unitId :list.unitId,
                            //         unitName :list.unitName,
                            //         userFamily :list.userFamily,
                            //         userId :list.userId,
                            //         userName :list.userFamily,
                            //         saturday :"",
                            //         sunday :"",
                            //         monday :"",
                            //         tuesday :"",
                            //         wednesday :"",
                            //         thursday  :"",
                            //         friday :list.customerFullName+ " - "+ list.productName+ " - " +list.productCount+ " - " +this.userFamily,
                            //     });
                            //
                        }
                    }


                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                //this.usr=[];
                this.userFamily="";
            },
            onViewMessageClicked(id) {

                this.$router.push({
                    name: 'myRequst',
                });
            },
            // validateDate(date) {
            //     return Moment(date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY')
            // },
            // onRowClicked(id){
            //     this.$router.push({
            //         name: 'competitionsList',
            //         params: {
            //             id: id
            //         }
            //     });
            // },
        },
        beforeRouteLeave(to, from, next) {
            $("body").removeClass("polygon");
            next();
        }
        ,

    }
</script>

<style lang="scss" scoped>
    .transform-layout {
        transform: translateY(70px);
    }

    .bg-gradient-pastel-yellow {
        /*higher saturation color*/
        /*background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%);*/
        background-color: #e79087;
        background-image: linear-gradient(315deg, #e79087 0%, #fcd181 74%);
    }

    .bg-gradient-pastel-red {
        /*higher saturation color*/
        /*background-image: linear-gradient(to right, #ff758c 0%, #ff7eb3 100%);*/
        background-color: #f9d1b7;
        background-image: linear-gradient(315deg, #f9d1b7 0%, #f894a4 74%);

    }

    .bg-gradient-pastel-green {
        /*higher saturation color*/
        /*background-image: linear-gradient(to right, #43e97b 0%, #38f9d7 100%);*/
        background-color: #70b2d9;
        background-image: linear-gradient(315deg, #70b2d9 0%, #39e5b6 74%);
    }

    .bg-gradient-pastel-cyan {
        /*higher saturation color*/
        /*background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);*/
        background-color: #b1ade2;
        background-image: linear-gradient(315deg, #b1ade2 0%, #7ddff8 74%);
    }

    .bg-gradient-pastel-purple {
        background-color: #f9c5d1;
        background-image: linear-gradient(315deg, #f9c5d1 0%, #9795ef 74%);
    }

    .bg-gradient-pastel-orange {
        background-color: #ffac81;
        background-image: linear-gradient(315deg, #ffac81 0%, #ff928b 74%);
    }

    .bg-gradient-pastel-light {
        background-color: #d9e4f5;
        background-image: linear-gradient(315deg, #d9e4f5 0%, #f5e3e6 74%);
    }

    .table-transparent {
        margin-top: 1rem;
    }

    .table-transparent th {
        background-color: transparent;
        border-color: #d2d4d7 !important;
        border-top: none !important;
        color: #8898aa;
    }

    .table-transparent td {
        border-color: #d2d4d7;
        color: #525f7f;
    }

    .dashed-create-container {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px dashed #e5e5e5;
        color: #e5e5e5;
        border-radius: 0.5rem;
        margin: 0 auto;
        transition: all 0.3s;
    }

    .dashed-create-container:hover {
        color: #ffffff;
        border-color: #ffffff;
        cursor: pointer;
    }

    .card.header-report {
        border: none;
        box-shadow: 0 15px 35px rgba(50, 50, 93, .2), 0 5px 15px rgba(0, 0, 0, .1) !important;
        color: white;
    }

    .card.activity-history {
        min-height: 240px;
    }

    @media (min-width: 1599px) {
        .card.activity-history {
            min-height: 260px;
        }
    }

    @media (min-width: 1601px) {
        .card.activity-history {
            min-height: 315px;
        }
    }

    .card.activity-history .sport-icon {
        max-width: 150px;
    }

    .card.activity-history .card-body {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .card.header-report .statistic-container {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .card.header-report .statistic-container > div {
        display: flex;
        align-items: center;
    }

    .card.header-report img.medal {
        max-width: 25px;
    }

    .loader,
    .loader:after {
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
    }

    .loader {
        margin: 0 auto;
        font-size: 10px;
        position: relative;
        text-indent: -9999em;
        border-top: 0.25em solid rgba(255, 255, 255, 0.2);
        border-right: 0.25em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.25em solid rgba(255, 255, 255, 0.2);
        border-left: 0.25em solid #ffffff;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation: load8 1.1s infinite linear;
        animation: load8 1.1s infinite linear;
    }

    .loader.lg,
    .loader.lg:after {
        border-radius: 50%;
        width: 5em;
        height: 5em;
    }

    .loader.lg {
        margin: 60px auto;
        border-top: 0.5em solid rgba(255, 255, 255, 0.2);
        border-right: 0.5em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.5em solid rgba(255, 255, 255, 0.2);
        border-left: 0.5em solid #ffffff;
    }

    @-webkit-keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

</style>